import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, MainContext } from '@blaze-cms/nextjs-components';
import buildLinkExtraProps from '../helpers/build-link-extra-props';

const BlazeLink = ({
  children,
  className,
  name,
  ariaLabel,
  href,
  as,
  shallow,
  scroll,
  gtmId,
  onClick
}) => {
  const { hasGTM } = useContext(MainContext);
  const gtmProps = hasGTM && !!gtmId ? { gtmId } : {};
  const linkExtraProps = buildLinkExtraProps({ className, name, as, ...gtmProps });
  if (!href) return children;

  return (
    <Link
      href={href}
      ariaLabel={ariaLabel}
      shallow={shallow}
      scroll={scroll}
      onClick={onClick}
      {...linkExtraProps}>
      {children}
    </Link>
  );
};

BlazeLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  href: PropTypes.string,
  as: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  shallow: PropTypes.bool,
  scroll: PropTypes.bool,
  gtmId: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string
};

BlazeLink.defaultProps = {
  children: [],
  as: '',
  href: '/',
  name: '',
  title: '',
  className: '',
  shallow: false,
  scroll: null,
  gtmId: '',
  onClick: null,
  ariaLabel: ''
};

export default BlazeLink;
